module.exports = __webpack_public_path__ + "static/img/14bg_1.320fc95.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/14bg_1.png
// module id = 644
// module chunks = 1